import { gql } from "@apollo/client";

// ─── Queries ─────────────────────────────────────────────────────────────────

export const ADMIN_SEARCH_USERS = gql`
  query AdminSearchUsers($search: String!, $limit: Int, $offset: Int) {
    adminSearchUsers(search: $search, limit: $limit, offset: $offset) {
      users {
        _id
        email
        firstName
        lastName
        role
        tier
        koinBalance
        lifetimeKoins
        isActive
        lastSeenAt
        avatar
        organizationNames
      }
      totalCount
    }
  }
`;

export const ADMIN_USER_DETAIL = gql`
  query AdminUserDetail($userId: ID!) {
    adminUserDetail(userId: $userId) {
      user {
        _id
        email
        firstName
        lastName
        role
        tier
        koinBalance
        lifetimeKoins
        isActive
        createdAt
        updatedAt
        lastLoginAt
        avatar
        onboardingStep
        currentStreakDays
        streakFreezesAvailable
      }
      organizations {
        organizationId
        organizationName
        role
        joinedAt
        isActive
      }
      totalLedgerEntries
      accountStatus
    }
  }
`;

export const ADMIN_USER_LEDGER = gql`
  query AdminUserLedger(
    $userId: ID!
    $first: Int
    $after: String
    $sourceType: KoinsSourceType
  ) {
    adminUserLedger(
      userId: $userId
      first: $first
      after: $after
      sourceType: $sourceType
    ) {
      edges {
        _id
        userId
        kind
        amount
        sourceType
        sourceId
        createdAt
        effectiveAt
        idempotencyKey
        reversalOfLedgerEntryId
        meta
        organizationId
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

// ─── Mutations ───────────────────────────────────────────────────────────────

export const ADJUST_KOINS = gql`
  mutation AdjustKoins($input: AdjustKoinsInput!) {
    adjustKoins(input: $input) {
      _id
      userId
      kind
      amount
      sourceType
      createdAt
      effectiveAt
      meta
    }
  }
`;
